import { render, staticRenderFns } from "./GroupPerson.vue?vue&type=template&id=e60cbd8e&scoped=true"
import script from "./GroupPerson.vue?vue&type=script&lang=js"
export * from "./GroupPerson.vue?vue&type=script&lang=js"
import style0 from "./GroupPerson.vue?vue&type=style&index=0&id=e60cbd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60cbd8e",
  null
  
)

export default component.exports